// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5bc4b8bb","239":"a8a1c658","248":"97ee1407","436":"851e4f18","453":"871aad73","455":"4987b914","909":"7dcab624"}[chunkId] + ".chunk.js";
};